import { theme } from '../../core/tokens';
const percentageRange = (value) => {
    if (value <= 0)
        return 0;
    if (value >= 100)
        return 100;
    return value;
};
export const getCurrentPercent = (percent, current, max, feedback, showPercentageWhenFail) => {
    if (!showPercentageWhenFail && (feedback || percent < 0))
        return 0;
    if (percent >= 0)
        return percentageRange(percent);
    return percentageRange((current * 10) / (max / 10));
};
export const getCurrentStatus = (value, feedback) => {
    if (feedback)
        return feedback.type;
    return value < 100 ? 'PROGRESS' : 'COMPLETED';
};
export const getFeedbackMessage = (status, feedback) => {
    const feedbacks = {
        CANCELED: 'Envio de arquivo cancelado',
        OTHER: feedback?.message,
    };
    return feedbacks[status];
};
export const getCurrentColorStatus = (status) => {
    const feedbacks = {
        PROGRESS: `linear-gradient(to right, ${theme.colors['--surface-accent']} 55%, ${theme.colors['--semantic-success-text']} 100%)`,
        COMPLETED: theme.colors['--semantic-success-base'],
    };
    return feedbacks[status] || theme.colors['--border-error'];
};
export const getAriaLabel = (value, feedbackMessage) => {
    if (feedbackMessage)
        return `Progresso falhou, ${feedbackMessage}`;
    return value < 100 ? `Estado de progresso em ${value}%` : 'Progresso completo';
};
//# sourceMappingURL=helpers.js.map